// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".error-message {\n    --bs-alert-color: #cc0000 !important;\n}\n\n.name {\n    padding: 0px 10px;\n}", "",{"version":3,"sources":["webpack://src/app/modules/auth/components/style.css"],"names":[],"mappings":"AAAA;IACI,oCAAoC;AACxC;;AAEA;IACI,iBAAiB;AACrB","sourcesContent":[".error-message {\n    --bs-alert-color: #cc0000 !important;\n}\n\n.name {\n    padding: 0px 10px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
